import { useMutation, useQueryClient, type MutationMeta } from '@tanstack/react-query';
import { useClientApis } from '../../hooks/ClientApisProvider.js';
import { issuesKeys } from '../queryKeys.js';

/**
 * Hard-deletes an issue (no soft-delete upstream — callers must confirm with
 * the user first). No optimistic removal: deletion is rare and irreversible,
 * so wait for the server, then invalidate the shared issues query — the daily
 * list, Hub and Monitor counts all refetch from the same key.
 */
export function useDeleteIssue(siteId: string | null, meta?: MutationMeta) {
  const { deleteIssueApi } = useClientApis().issues;
  const qc = useQueryClient();
  return useMutation({
    meta,
    mutationFn: ({ issueId }: { issueId: string }) => {
      if (!siteId) throw new Error('deleteIssue called without siteId');
      return deleteIssueApi(siteId, issueId);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: issuesKeys.list(siteId) });
    },
  });
}
